"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var redux_1 = require("redux");

var redux_thunk_1 = __importDefault(require("redux-thunk"));

var composeEnhancers = window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;

function configureStore(rootReducer, initialState, middlewares) {
  if (middlewares === void 0) {
    middlewares = [];
  }

  middlewares.unshift(redux_thunk_1.default);
  var enhancer = composeEnhancers(redux_1.applyMiddleware.apply(void 0, middlewares));
  return redux_1.createStore(rootReducer, initialState, enhancer);
}

exports.configureStore = configureStore;